interface WordInfo {
    definition: string;
    partOfSpeech: string;
    explanation: string;
    audio: string;
}
//export interface not needed yet
interface DictionaryType {
    [key: string]: WordInfo;
}

const dictionary: DictionaryType = {
    "O Ηρακλής": {
        definition: "Hercules",
        partOfSpeech: "Noun",
        explanation: "Hercules is a man. In Greek, all names have articles. Masculine nouns: article is masculine and the nouns end with -ος, -ης, or -ας.",
        audio: "/audio/Vocab1.m4a"
    },
    "μήνυμα": {
        definition: "Message",
        partOfSpeech: "Noun",
        explanation: "Message is a noun that uses the neuter article (το). Often, neuter nouns and plurals end in -α (-a) or -η (-ē).",
        audio: "/audio/Vocab 2.m4a"
    },
    "θεό Απόλλωνα": {
        definition: "God Apollo",
        partOfSpeech: "Noun",
        explanation: "Nouns change their endings based on the grammatical structure of the sentence used. The meaning of the noun does not change.",
        audio: "/audio/Vocab 3.m4a"
    },
    "Φεύγει": {
        definition: "To go or to leave",
        partOfSpeech: "Verb",
        explanation: "Φεύγω -verbs ending in -ω are usually considered regular verbs. Verbs can be identified with their endings. The third person conjugation of this verb ends with -ει.",
        audio: "/audio/Vocab 4.m4a"
    },
    "την Πελοπόννησο": { //change
        definition: "The Peloponnese",
        partOfSpeech: "Noun",
        explanation: "A region in southern greece",
        audio: "/audio/Vocab 5.m4a"
    },
    "στις Μυκήνες": {
        definition: "Mycenae",
        partOfSpeech: "Noun",
        explanation: "A Greek city dating back to ancient times. The city of the Trojan War.",
        audio: "/audio/Vocab 7.m4a"
    },
    "Πηγαίνει": {
        definition: "Goes",
        partOfSpeech: "Verb",
        explanation: "Means to go. Verbs can be identified with their endings",
        audio: "/audio/Vocab 6.m4a"
    },
    "ο Βασιλιάς Ευρυσθέας": {
        definition: "The King Eurystheus",
        partOfSpeech: "Noun",
        explanation: "A male person. The endings of these words are connected to the masculine article -ας.",
        audio: "/audio/Vocab 8.m4a"
    },
    "δίνει": {
        definition: "To give",
        partOfSpeech: "Verb",
        explanation: "Δίνω - verbs ending in -ω. This verb is considered irregular. Verbs can be identified with their endings. This verb ends with -ει.",
        audio: "/audio/Vocab 9.m4a"
    },
    "έναν άθλο": {
        definition: "A/one labor",
        partOfSpeech: "Noun",
        explanation: "-ν is added to the article because it is followed by a vowel. Using a or one in front of the noun shows that it is singular.",
        audio: "/audio/Vocab 10.m4a"
    },
    "Πρέπει": {
        definition: "Must",
        partOfSpeech: "Verb",
        explanation: "An auxiliary verb. This verb expresses what someone must do.",
        audio: "/audio/Vocab 11.m4a"
    },
    "να σκοτώσει": {
        definition: "To kill",
        partOfSpeech: "Verb",
        explanation: "Να means To or in order to. The meaning of this verb is: in order to kill (the Nemean Lion).",
        audio: "/audio/Vocab 12.m4a"
    },
    "είναι": {
        definition: "To be",
        partOfSpeech: "Verb",
        explanation: "Είμαι means 'It is'. This is an irregular verb and does not follow the patterns of the regular verb forms.",
        audio: "/audio/Vocab 15.m4a"
    },
    "το λιοντάρι": {
        definition: "The Lion. Lion is neuter so in Greek, it has a neuter article (τo) and it ends with -ι.",
        partOfSpeech: "Noun",
        explanation: "Nouns refer to people, places and things. They can be determined by masculine, feminine and neuter articles found in front of the nouns.",
        audio: "/audio/Vocab 13.m4a"
    },
    "Η Νεμέα": {
        definition: "Nemea",
        partOfSpeech: "Noun Nemea in ancient Greek means \"wooded district\"",
        explanation: "Nemea is a place in southern Greece in the area known as the Peleponese.",
        audio: "/audio/Vocab 14.m4a"
    },
    "Ο τόπος": {
        definition: "The place or location",
        partOfSpeech: "Noun in the masculine form",
        explanation: "Masculine nouns: article is masculine and the nouns end with -ος, -ης, or -ας",
        audio: "/audio/Vocab 16.m4a"
    },
    "όνειρο": {
        definition: "dream",
        partOfSpeech: "Noun.",
        explanation: "Dream a noun in the neuter form. In Greek, it has a neuter article (τo) and it can end with -o. Neuter nouns can usually end in -ι, -ο, -α, -ος, -ιμο",
        audio: "/audio/Vocab 17.m4a"
    },
    "Έχει": {
        definition: "To have",
        partOfSpeech: "Verb έχω",
        explanation: "This is an irregular verb and does not follow the patterns of the regular verb forms.",
        audio: "/audio/Vocab 18.m4a"
    },
    "βουνά": {
        definition: "To have",
        partOfSpeech: "Verb έχω",
        explanation: "New Ones.",
        audio: "/audio/Vocab 19.m4a"
    },
    "με δέντρα": {
        definition: "The trees",
        partOfSpeech: "Plural noun in the neuter form.",
        explanation: "Plural nouns can end with -α. In the singular the -α changes to -o. The article also changes from Tα into To",
        audio: "/audio/Vocab 20.m4a"
    },
    "άγρια ζώα": {
        definition: "Wild animals",
        partOfSpeech: "Noun",
        explanation: "Plural noun in the neuter form with the adjective 'wild' in front of the noun. Plural nouns can end with -α. In the singular, the -α changes to -o. The article also changes from Τa into To.",
        audio: "/audio/Vocab 21.m4a"
    },
    "τρομοκρατεί": {
        definition: "Terrorizes or Terrifies",
        partOfSpeech: "Verb",
        explanation: "Verbs can be identified with their endings. This verb ends with -ει.",
        audio: "/audio/Vocab 23.m4a"
    },
    "την πόλη": {
        definition: "The city",
        partOfSpeech: "Noun",
        explanation: "Feminine form. This article is used to show a modified noun. The -v is added when the noun that follows starts with a vowel or a plosive consonant (ie κ, ξ, π, τ, ψ, γκ, ντ, μπ).",
        audio: "/audio/Vocab 22.m4a"
    },
    "Τρώει": {
        definition: "To eat",
        partOfSpeech: "Verb",
        explanation: "Τρώω - verbs ending in -ω. This verb is considered irregular. Verbs can be identified with their endings. This verb ends with -ει.",
        audio: "/audio/Vocab 24.m4a"
    },
    "ανθρώπους": {
        definition: "The people",
        partOfSpeech: "Noun",
        explanation: "Plural noun in the masculine form. In the plural, the intonation also changes. The singular form is άνθρωπος.",
        audio: "/audio/Vocab 25.m4a"
    },
    "πάει": {
        definition: "To go",
        partOfSpeech: "Verb",
        explanation: "Regular verb. 3rd person singular present form of πάω. Verbs can be identified with their endings. This verb ends with -ει.",
        audio: "/audio/Vocab 26.m4a"
    },
    "τον ουρανό": { //different
        definition: "The sky",
        partOfSpeech: "Noun",
        explanation: "Singular noun in the neuter form. This article is used to show a modified noun. The -v is added when the noun that follows starts with a vowel or a plosive consonant (ie κ, ξ, π, τ, ψ, γκ, ντ, μπ).",
        audio: "/audio/Vocab27.m4a"
    },
    "πηγές": {// different
        definition: "Water well",
        partOfSpeech: "Noun",
        explanation: "Plural noun, feminine form. Η πηγή. The form changes from singular to plural as does the spelling: -η to -ες.",
        audio: "/audio/Vocab 28.m4a"
    },
    "σπηλιές": {
        definition: "Caves",
        partOfSpeech: "Noun",
        explanation: "Plural noun, feminine form. Η σπηλιά. The form changes from singular to plural as does the spelling: -α to -ες.",
        audio: "/audio/Vocab 29.m4a"
    },
    "λύκους": {
        definition: "Wolves",
        partOfSpeech: "Noun",
        explanation: "Plural noun in the masculine form. Ο λύκος. The form changes from singular to plural as does the spelling: -ος to -ους.",
        audio: "/audio/Vocab 30.m4a"
    },
    "αλεπούδες": {
        definition: "Foxes",
        partOfSpeech: "Noun",
        explanation: "Plural noun, feminine form. Η αλεπού. The form changes from singular to plural as does the spelling: -ου to -ουδες.",
        audio: "/audio/Vocab 31.m4a"
    },
    "τσακάλια": {
        definition: "Jackals",
        partOfSpeech: "Noun",
        explanation: "Plural noun in the neuter form. Το τσακάλι. The form changes from singular to plural as does the spelling: -ι to -α.",
        audio: "/audio/Vocab 32.m4a"
    },
    "Ψάχνει": {
        definition: "Search",
        partOfSpeech: "Verb",
        explanation: "Regular verb. 3rd person singular present form of ψάχνω. Verbs can be identified with their endings. This verb ends with -ει.",
        audio: "/audio/Vocab 39.m4a"
    },
    "μέρες": {
        definition: "Days",
        partOfSpeech: "Noun",
        explanation: "Plural noun, feminine form. Η ημέρα. The form changes from singular to plural as does the spelling: -α to -ες.",
        audio: "/audio/Vocab 33.m4a"
    },
    "νύχτες": {
        definition: "Nights",
        partOfSpeech: "Noun",
        explanation: "Plural noun, feminine form. Η νύχτα. The form changes from singular to plural as does the spelling: -α to -ες.",
        audio: "/audio/Vocab 34.m4a"
    },
    "περπατάει": {
        definition: "To walk",
        partOfSpeech: "Verb",
        explanation: "Regular verb. 3rd person singular present form of περπατώ. Verbs can be identified with their endings. This verb ends with -ει.",
        audio: "/audio/Vocab 35.m4a"
    },
    "κοιτάζει": {
        definition: "To look",
        partOfSpeech: "Verb",
        explanation: "Regular verb. 3rd person singular present form of κοιτάζω. Verbs can be identified with their endings. This verb ends with -ει.",
        audio: "/audio/Vocab 36.m4a"
    },
    "Κρατάει": {
        definition: "To hold",
        partOfSpeech: "Verb",
        explanation: "Regular verb. 3rd person singular present form of κρατάω. Verbs can be identified with their endings. This verb ends with -ει.",
        audio: "/audio/Vocab 37.m4a"
    },
    "ρόπαλο": {
        definition: "Club",
        partOfSpeech: "Noun",
        explanation: "Singular noun, neuter form. You will often find Hercules holding a club to symbolize his strength and power. Although you can often see Hercules with a sword or a bow & arrow.",
        audio: "/audio/Vocab 38.m4a"
    },
    "περιμένει": {
        definition: "To wait",
        partOfSpeech: "Verb",
        explanation: "Regular verb. 3rd person singular present form of περιμένω. Verbs can be identified with their endings. This verb ends with -ει.",
        audio: "/audio/Vocab40.m4a"
    },
    "πλησιάζει": {
        definition: "To come closer/approach",
        partOfSpeech: "Verb",
        explanation: "Regular verb. 3rd person singular present form of πλησιάζω. Verbs can be identified with their endings. This verb ends with -ει.",
        audio: "/audio/Vocab 41.m4a"
    },
    "τεράστιο": {
        definition: "Enormous",
        partOfSpeech: "Adjective",
        explanation: "A word that describes a noun. The adjective in Greek also takes on the form of the noun based on the masculine, feminine, or neuter form.",
        audio: "/audio/Vocab 42.m4a"
    },
    "Ήρθε η ώρα": {
        definition: "The time has come!",
        partOfSpeech: "Expression",
        explanation: "An expression used to indicate that the moment has arrived.",
        audio: "/audio/Vocab 43.m4a"
    },
    "σημαδεύει": {
        definition: "Take aim",
        partOfSpeech: "Verb",
        explanation: "Regular verb. 3rd person singular present form of σημαδεύω. Verbs can be identified with their endings. This verb ends with -ει.",
        audio: "/audio/Vocab 44.m4a"
    },
    "Παίρνει": {
        definition: "To take",
        partOfSpeech: "Verb",
        explanation: "Regular verb. 3rd person singular present form of παίρνω. Verbs can be identified with their endings. This verb ends with -ει.",
        audio: "/audio/Vocab 45.m4a"
    },
    "χτυπάει": {
        definition: "To hit",
        partOfSpeech: "Verb",
        explanation: "Regular verb. 3rd person singular present form of χτυπάω. Verbs can be identified with their endings. This verb ends with -ει.",
        audio: "/audio/Vocab 46.m4a"
    },
    "μπαίνει": {
        definition: "To go into",
        partOfSpeech: "Verb",
        explanation: "Regular verb. 3rd person singular present form of μπαίνω. Verbs can be identified with their endings. This verb ends with -ει.",
        audio: "/audio/Vocab 47.m4a"
    },
    "παλεύει": {
        definition: "To fight",
        partOfSpeech: "Verb",
        explanation: "Regular verb. 3rd person singular present form of παλεύω. Verbs can be identified with their endings. This verb ends with -ει.",
        audio: "/audio/Vocab 48.m4a"
    },
    "τα χέρια": {
        definition: "Hands",
        partOfSpeech: "Noun",
        explanation: "Plural noun in the neuter form. The article changes from Τa into To. The singular form is το χέρι.",
        audio: "/audio/Vocab 49.m4a"
    },
    "το δέρμα": {
        definition: "Skin",
        partOfSpeech: "Noun",
        explanation: "Singular noun in the neuter form. All nouns have articles.",
        audio: "/audio/Vocab 50.m4a"
    },
    "φοράει": {
        definition: "To wear",
        partOfSpeech: "Verb",
        explanation: "Regular verb. 3rd person singular present form of φοράω. Verbs can be identified with their endings. This verb ends with -ει.",
        audio: "/audio/Vocab 51.m4a"
    },
    "τη λεοντή": {
        definition: "Skinned lion",
        partOfSpeech: "Noun",
        explanation: "This is the name of the skinned lion that Hercules placed on his own body as a symbol of victory in the first labor.",
        audio: "/audio/Vocab 52.m4a"
    },
    "Τρομάζει": {
        definition: "To get scared/frightened",
        partOfSpeech: "Verb",
        explanation: "Regular verb. 3rd person singular present form of τρομάζω. Verbs can be identified with their endings. This verb ends with -ει.",
        audio: "/audio/Vocab 53.m4a"
    },
    "πιθάρι": {
        definition: "An Urn",
        partOfSpeech: "Singular noun",
        explanation: "Ancient pottery",
        audio: "/audio/Vocab 54.m4a"
    }
};




export default dictionary